import { render, staticRenderFns } from "./OOLocation.vue?vue&type=template&id=5c4e09b5&scoped=true&"
import script from "./OOLocation.vue?vue&type=script&lang=ts&"
export * from "./OOLocation.vue?vue&type=script&lang=ts&"
import style0 from "./OOLocation.vue?vue&type=style&index=0&id=5c4e09b5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4e09b5",
  null
  
)

export default component.exports